module.exports = __webpack_public_path__ + "static/media/dinein-white.700e84d1.svg";